import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const isShowAveStringEnabledSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('showAveString'),
)

export default isShowAveStringEnabledSelector
